import React, { useEffect, useState, useSyncExternalStore } from "react";
import { Backdrop } from "@mui/material";
import { Blocks } from "react-loader-spinner";
import { getPendingCount, subscribe } from "../../helpers/apiQueue";

// Small delay before hiding so the loader doesn't flicker between
// back-to-back queued calls.
const HIDE_DELAY_MS = 150;

const GlobalApiLoader = () => {
  const pending = useSyncExternalStore(subscribe, getPendingCount);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (pending > 0) {
      setVisible(true);
      return undefined;
    }
    const timer = setTimeout(() => setVisible(false), HIDE_DELAY_MS);
    return () => clearTimeout(timer);
  }, [pending]);

  return (
    <Backdrop sx={{ color: "#fff", zIndex: 1060 }} open={visible}>
      <Blocks
        visible={true}
        height="80"
        width="80"
        ariaLabel="blocks-loading"
        wrapperStyle={{}}
        wrapperClass="blocks-wrapper"
        color="#00b6ce"
      />
    </Backdrop>
  );
};

export default GlobalApiLoader;
